import { render } from "./PdfPart.vue?vue&type=template&id=20a09e6a"
import script from "./PdfPart.vue?vue&type=script&lang=js"
export * from "./PdfPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__